<template>
<div>
    <div class="itemList">
        <div class="itemDiv" v-for="item in dataList" :key="item.id">
            <div class="leftDiv">
                <p>                      
                    {{item.companyName}},{{item.jobName}},公司联系人{{item.contactsName + ' ' + item.contactsTel}},线索提供者手机{{item.mobile}},线索提交时间：{{item.createTime}}
                </p>
                <div>
                    <el-button @click="clxs1(item.id,0)">处理完毕，无奖励</el-button>
                    <el-button @click="clxs1(item.id,1)">处理完毕，奖励一年会员</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageNumber"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="pageTotal">
    </el-pagination>
  </div>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%">
    <span>是否处理这条奖励信息</span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;clxs()">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'xs',
    props: {},
    data () {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            dialogVisible: false,
            setid: '',
            setnum: ''
        }
    },
    methods: {
        changePostionName: function () {
            this.pageNumber = 1
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            let url = ''
            url = Config.path + '/api/v1.0/clue/clueReportlist/' + this.pageNumber + '/' + this.pageSize;
           axios({
                method: 'GET',
                url: url,
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {},
                data: {}
            }).then(function(response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    for (let i in demo) {
                        if (demo[i].userInfo) {
                            demo[i].userObj = JSON.parse(demo[i].userInfo)
                        }
                    }
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        clxs1: function(id, status) {
            this.setid = id
            this.setnum = status
            this.dialogVisible = true
        },
        clxs: function () {
            let id = this.setid
            let status = this.setnum
            let that = this
           axios({
                method: 'GET',
                url: Config.path + '/api/v1.0/clue/fixclueReport/' + id + '/' + status,
                headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8',
                    token: localStorage.getItem('token')},
                params: {},
                data: {}
            }).then(function(response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '处理完毕',
                        type: 'success'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function(error) {
                 // eslint-disable-next-line
                console.log(error)
            })
        },
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
    .itemList{
        margin-top: 20px;
    }

    .itemList .itemDiv{
        background-color: #ffffff;
        width: 80%;
        margin: 0 auto 15px auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 25px;
        border-radius: 8px;
        min-height: 200px;
        box-shadow: 10px 10px 10px rgba(0,0,0,0.5);
    }

    .itemList .itemDiv .leftDiv{
        width: 70%;
    }

    .itemList .itemDiv .leftDiv p{
        font-size: 18px;
        color: #757373;
    }

    .itemList .itemDiv .leftDiv div{
        padding: 30px 0;
    }

    .itemList .itemDiv .rightDiv{
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .itemList .itemDiv .rightDiv p{
        font-size: 32px;
        color: #1AAD19;
        text-align: center;
    }

    .itemList .itemDiv .rightDiv div{
        padding: 30px 0;
        display: flex;
        flex-direction: row;
        justify-content:space-around;
        align-items: center;
    }

    .block{
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    }
</style>
